import { FieldValues, SubmitHandler, useForm } from 'react-hook-form'
import { useDispatch } from '../../redux/hooks'
import companyActions from '../../redux/modules/company/actions'
import companySelectors from '../../redux/modules/company/selectors'
import { store } from '../../redux/store'
import switchCompanyCardForm from './switchCompanyCardForm'
import useStableCallback from '../../hooks/shared/useStableCallback'
import { useCallback } from 'react'

export const useSwitchCompanyCardForm = ({
  onSubmitSuccess,
  onSubmitError,
}: {
  onSubmitSuccess?: (companyCardId: string) => void
  onSubmitError?: (error: string) => void
}) => {
  const dispatch = useDispatch()
  const { handleSubmit, reset, setError, ...rest } = useForm()
  const onSubmitSuccessStable = useStableCallback((companyCardId: string) => {
    return onSubmitSuccess?.(companyCardId)
  })
  const onSubmitErrorStable = useStableCallback((error: string) => {
    return onSubmitError?.(error)
  })
  const onSubmit: SubmitHandler<FieldValues> = useCallback(
    async (params, event) => {
      const companyId = companySelectors.getCompanyId(store.getState())
      // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
      const companyCardId = event?.target?.value as string | undefined
      if (!companyCardId || !companyId) {
        setError('root', { message: 'Failed to submit.' })
        return
      }
      await switchCompanyCardForm
        .onSubmit({
          companyId,
          companyCardId,
        })
        .then(() => {
          dispatch(companyActions.switchCard({ companyCardId }))
          onSubmitSuccessStable(companyCardId)
        })
        .catch((error: Error) => {
          setError('root', { message: error.message })
          onSubmitErrorStable(error.message)
        })
    },
    [dispatch, onSubmitErrorStable, onSubmitSuccessStable, setError],
  )
  const submit = useStableCallback(handleSubmit(onSubmit))
  return {
    ...rest,
    submit,
    onSubmit,
    handleSubmit,
    reset,
    setError,
  }
}
